import React, { FunctionComponent } from 'react'

import { Footer } from './Footer'
import { useAppContext } from '../../context/app'

export const FooterContainer: FunctionComponent = () => {
  const { supportContact } = useAppContext()
  return <Footer supportContact={supportContact} />
}
